import CardSmall from '../../../components/CockpitCards/CardSmall'
import BookingCardText from './BookingCardText'
import ResponsiveDateTimePickers from '../../../components/DatePicker/ResponsiveDateTimePickers'



export default function BookingCard() {

return(
<>

<CardSmall 

  headline = "BOOK A SESSION" 
  subtext = {<BookingCardText />}
  cardlines = {<>

      <ResponsiveDateTimePickers />

      </> }

/>

</>
)
}

